import type { ReactNode } from "react";

export function LoadingState({ label = "Loading" }: { label?: string }) {
  return (
    <div className="state-panel" role="status">
      <span className="spinner" aria-hidden="true" />
      <span>{label}…</span>
    </div>
  );
}

export function EmptyState({
  title,
  message,
  action
}: {
  title: string;
  message: string;
  action?: ReactNode;
}) {
  return (
    <div className="state-panel state-panel--empty">
      <p className="state-panel__title">{title}</p>
      <p>{message}</p>
      {action}
    </div>
  );
}

export function InlineError({
  message,
  retry
}: {
  message: string;
  retry?: () => void;
}) {
  return (
    <div className="inline-error" role="alert">
      <div>
        <strong>Something went wrong.</strong>
        <p>{message}</p>
      </div>
      {retry && (
        <button type="button" className="button button--small" onClick={retry}>
          Try again
        </button>
      )}
    </div>
  );
}
